<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="https://www.100ec.cn/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E7%94%9F%E6%B4%BB&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>网经社数字经济台</span>
        <a href="http://DE.100ec.cn/" target="_blank">更多</a>
      </div>
      <div style="width: 300px">
        <a href="http://DE.100ec.cn/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/szjj550.jpg" />
        </a>
      </div>
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社数字零售台</span>
        <a href="http://DR.100ec.cn/" target="_blank">更多</a>
      </div>
      <div style="width: 300px">
        <a href="http://DR.100ec.cn/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/szls550.jpg" />
        </a>
      </div>
    </div> -->
    <!-- <div style="width: 365px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr.jpg" />
      </a>
    </div> -->
    <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/cpfw-2025-7-10/szsh.jpg"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "数字生活",
        tabs: [
          "餐饮外卖",
          "家政服务",
          "在线票务",
          "社区服务",
          "互联网家装",
          "互联网房产",
        ],
      },
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
};
</script>